import { JOIN_URL } from "../config";

export async function shareText(title: string, text: string): Promise<"shared" | "copied"> {
  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title, text });
      return "shared";
    } catch (e) {
      if (e instanceof DOMException && e.name === "AbortError") throw e;
    }
  }
  await navigator.clipboard.writeText(text);
  return "copied";
}

export function downloadLinkMessage(_webUrl?: string): string {
  return `Join Sundius Family — our private family tree, photos, and games.

${JOIN_URL}

Open the link (any phone or computer — or get the iPhone app from there). You'll need an invite code from someone in the family to unlock.`;
}

export function familyInviteMessage(
  _webUrl: string,
  recipientName: string,
  code: string,
): string {
  return `Hi ${recipientName}! Here's your invite to Sundius Family.

${JOIN_URL}

Your code: ${code}

Open the link and enter the code when prompted.`;
}

export function additionalDeviceMessage(_webUrl: string, code: string): string {
  return `Sundius Family — set up your other device.

${JOIN_URL}

Your code: ${code}`;
}

export function guestInviteMessage(_webUrl: string, code: string): string {
  return `Welcome to Sundius Family!

${JOIN_URL}

Your guest code: ${code}`;
}
